import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BaseComponent } from '../../core';
import { LibCoreLayoutModule } from '../core-layout';
import { PhoneNumberInputModule } from '../phone-number-input';

export interface ContactDataFormData {
  email: string;
  phoneNr: string;
}

@Component({
  selector: 'lib-contact-data-form',
  templateUrl: './contact-data-form.component.html',
  styleUrls: ['./contact-data-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    TranslateModule,
    ReactiveFormsModule,
    PhoneNumberInputModule,
    // Material design
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class ContactDataFormComponent extends BaseComponent {
  @Input() set email(value: string | undefined) {
    if (value !== this.controlEmail.value) {
      this.controlEmail.setValue(value);
    }
  }

  @Input() set phoneNr(value: string | undefined) {
    if (value !== this.controlPhoneNr.value) {
      this.controlPhoneNr.setValue(value);
    }
  }

  @Input() set disableEmail(value: boolean | undefined) {
    if (value) {
      this.controlEmail.disable();
    } else {
      this.controlEmail.enable();
    }
  }

  @Output() contactDataChanged = new EventEmitter<ContactDataFormData>();

  public readonly FORM_NAME = {
    EMAIL: 'email',
    PHONE_NUMBER: 'phoneNr',
  };

  public submitForm: FormGroup;

  constructor() {
    super();

    this.submitForm = new FormGroup({
      [this.FORM_NAME.EMAIL]: new FormControl(null, [
        Validators.required,
        Validators.email,
      ]),
      [this.FORM_NAME.PHONE_NUMBER]: new FormControl(null, [
        Validators.required,
      ]),
    });

    this.submitForm.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((value: ContactDataFormData) => {
        if (this.submitForm.valid) {
          this.contactDataChanged.emit({
            email: value.email,
            phoneNr: value.phoneNr,
          });
        } else {
          this.contactDataChanged.emit(undefined);
        }
      });
  }

  public get controlEmail(): AbstractControl {
    return this.submitForm.get(this.FORM_NAME.EMAIL)!;
  }

  public get controlPhoneNr(): AbstractControl {
    return this.submitForm.get(this.FORM_NAME.PHONE_NUMBER)!;
  }
}
